import React from "react";
import { Card, Grid, Typography } from "@mui/material";

const darkCard = {
  backgroundColor: "#161B22",
  border: "1px solid rgba(255,255,255,0.06)",
};

export default function MunicipalityTable({
  municipalityTableData,
  isSuccessMunicipalityTableData,
}) {
  if (!isSuccessMunicipalityTableData) return <></>;

  const rows = [
    { label: "Saturdays, Morning", key: "saturday_morning_ls" },
    { label: "Saturdays, Evening", key: "saturday_evening_ls" },
    { label: "Weekdays, Morning",  key: "weekday_morning_ls" },
    { label: "Weekdays, Evening",  key: "weekday_evening_ls" },
  ];

  const headerStyle = {
    color: "rgba(255,255,255,0.4)",
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  };

  const rowBorder = { borderBottom: "1px solid rgba(255,255,255,0.06)" };

  return (
    <Grid container spacing={0.5} direction="row" alignItems="stretch">
      {/* Label column */}
      <Grid item xs={2}>
        <Card sx={{ padding: 3, display: "flex", flexDirection: "column", justifyContent: "center", height: "80%", ...darkCard }}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#e0e6f0" }}>
            Average Power (MVA)
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "0.78rem", mt: "4px" }}>
            By schedule window
          </Typography>
        </Card>
      </Grid>

      {/* Data column */}
      <Grid item xs={10}>
        <Card sx={{ padding: 0, display: "flex", flexDirection: "column", height: "80%", overflow: "hidden", ...darkCard }}>
          <Grid container sx={{ px: 3, py: 1.5, ...rowBorder }}>
            <Grid item xs={3} />
            <Grid item xs={3}>
              <Typography sx={headerStyle}>Normalized Baseline (MVA)</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={headerStyle}>Assessment (MVA)</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={headerStyle}>Saving (MVA)</Typography>
            </Grid>
          </Grid>

          {rows.map(({ label, key }, idx) => (
            <Grid
              container
              key={key}
              sx={{
                px: 3,
                py: 1.5,
                ...(idx < rows.length - 1 ? rowBorder : {}),
                "&:hover": { backgroundColor: "rgba(255,255,255,0.02)" },
              }}
            >
              <Grid item xs={3}>
                <Typography sx={{ color: "#FDB940", fontSize: "0.88rem" }}>{label}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#e0e6f0", fontSize: "0.88rem" }}>
                  {(municipalityTableData[key]?.baseline_demand_total / 1000000 || 0).toFixed(2)} MVA
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#e0e6f0", fontSize: "0.88rem" }}>
                  {(municipalityTableData[key]?.assessment_demand_total / 1000000 || 0).toFixed(2)} MVA
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#e0e6f0", fontSize: "0.88rem" }}>
                  {Math.max(
                    municipalityTableData[key]?.baseline_demand_total / 1000000 -
                    municipalityTableData[key]?.assessment_demand_total / 1000000,
                    0
                  ).toFixed(2)} MVA
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Card>
      </Grid>
    </Grid>
  );
}
